<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
        </div>
        <div class="cotainer">
          <iframe :src="service_link" scrolling="auto" frameborder="0" class="frame"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'service',
    data () {
        return {
          theme: false,
          service_link: ''
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.service_link = this.$route.query.url;
    },
    mounted() {

    },
    methods: {
       back(){
           this.$router.go(-1);
       },
    },
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        left: 0;
        right: 0;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .frame{
      width: 100%;
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/service.vue